import { GetPageByRouteQuery } from "apollo"
import { extractProperty } from "./extractProperty"
import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

type Parent = {
  url: string | null | undefined
  id: number | null | undefined
  level: number | null | undefined
  parent: Parent
}

export type Breadcrumbs = {
  url: string
  title: string
  isPage?: boolean
}[]

function hasPageContent(data: any): boolean {
  if (!data?.properties || !Array.isArray(data.properties)) return false
  const meaningfulProps = data.properties.filter((prop: any) => {
    if (prop.propertyName === "titleBreadcrumbs") return false
    const val = prop.propertyValue
    if (!val) return false
    return (
      val.value || val.richText || val.blocks?.length || val.mediaItems?.length ||
      val.links?.length || val.contentList || val.dateTime
    )
  })
  return meaningfulProps.length > 0
}

function extractTitle(data: any) {
  const pageBlock = extractProperty(data, "pageInfoAndMetaTags")
  if (pageBlock) {
    data = pageBlock?.[0]
  }
  const title = extractProperty(data, "titleBreadcrumbs") as string | undefined
  return title
}


export function getBreadCrumbs(data: GetPageByRouteQuery, locale: string) {
  const self = extractTitle(data.page)
  const selfObject: { url: string; title: string } = {
    title: self || "",
    url: getNonUmbracoUrl(data.page?.url || ""),
  }
  const parent = data.page?.parent as Parent
  const parents: Array<{ url: string; title: string; clickable?: boolean }> = []
  function recurse(currentParent: Parent | null) {
    if (
      currentParent &&
      currentParent.level !== null &&
      currentParent.level !== undefined &&
      currentParent.level >= 3
    ) {
      const parentTitle = extractTitle(currentParent)
      const parentUrl = getNonUmbracoUrl(currentParent.url || "")
      if (parentTitle) {
        parents.push({
          url: parentUrl,
          title: parentTitle,
          clickable: hasPageContent(currentParent),
        })
      }
      if (currentParent.parent) {
        recurse(currentParent.parent)
      }
    }
  }
  recurse(parent ?? null)
  return {
    selfObject,
    parents: [
      {
        title:
          {
            he: "ראשי",
            ar: "الرئيسية",
            ru: "Главная",
            en: "Home page",
          }[locale] || "ראשי",
        url:
          {
            he: "/",
            ar: "/",
            ru: "/",
            en: "/",
          }[locale] || "/",
        clickable: true, // Home page is always clickable
      },
      ...parents.reverse(),
    ],
  }
}

export type BreadCrumbs = {
  selfObject: { url: string; title: string }
  parents: Array<{ url: string; title: string; clickable?: boolean }>
}
